import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationBaseFinanceAttributions: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTIONS,
	},

	getRegulationBaseFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].GET_REGULATION_BASE_FINANCE_ATTRIBUTION,
	},

	createRegulationBaseFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].CREATE_REGULATION_BASE_FINANCE_ATTRIBUTION,
	},
	patchRegulationBaseFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PATCH_REGULATION_BASE_FINANCE_ATTRIBUTION,
	},
	putRegulationBaseFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].PUT_REGULATION_BASE_FINANCE_ATTRIBUTION,
	},
	deleteRegulationBaseFinanceAttribution: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].DELETE_REGULATION_BASE_FINANCE_ATTRIBUTION,
	},
}